<template>
  <div class="topcontainer"> 
    <NavHeader />
  </div>
  <div class="bodycontainer"> 
    <DisplaySigns />
  
  </div>
</template>


<script>
 import DisplaySigns from '@/components/DisplaySigns.vue'
 import NavHeader from '@/components/NavHeader.vue'
// import signs from '@/components/signs.json'

export default {
  name: 'Home',
  components: {
    DisplaySigns,
    NavHeader
  }
}
</script>

<style >
body{
          background: url('../assets/img/space-Bg.jpg') no-repeat center center fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      margin: 0;
      /* height: 100vh; */
      width: 100%;
}
.topcontainer {
  display: flex;
  width: 100%; 
  /* background-color: red; */
  /* padding:5px; */
  /* height: 30vh; */
}
.bodycontainer {
  /* background-color: green; */
  /* width: 100%;  */
    padding: 0;
    margin: 0;
    list-style: none;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-flow: row wrap;
    justify-content: space-around;
  /* padding:5px; */
}

</style>